import { render, staticRenderFns } from "./RightNavigation.vue?vue&type=template&id=58dbce0a&"
import script from "./RightNavigation.vue?vue&type=script&lang=js&"
export * from "./RightNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports